import React from 'react';
import CRUDDetailPage from '../../../../shared/components/crud/CRUDDetailPage';
import { stockManagementConfig } from '../config/stockManagementConfig';
import { StockService } from '../../../../shared/services/stockService';

/**
 * StockManagementDetail - URL-based detail page for Stock Management
 * Handles view, edit, and add modes with ID from URL params
 */
export default function StockManagementDetail() {

      console.log("🚀 ~ StockManagementDetail ~ stockManagementConfig:", stockManagementConfig)
  return (
    <CRUDDetailPage
      config={stockManagementConfig}
      service={StockService}
    />
  );
}
